import makeStyles from '@mui/styles/makeStyles'
import { getBuildHeight } from '../../../build/utils/get-build-height'

export const useStyles = makeStyles(({ spacing }) => ({
  root: {
    height: '100%',
    width: '100%'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(3),
    marginTop: spacing(3)
  },
  input: {
    marginTop: spacing(3)
  },
  pageContainer: {
    overflowY: 'auto',
    maxHeight: getBuildHeight(),
    margin: 0,
    padding: 0,
    /* Firefox */
    scrollbarWidth: 'thin',
    scrollbarColor: '#A6A6A6 #EBEBEB',
    scrollBehavior: 'smooth',
    scrollPaddingRight: '4px',
    paddingRight: '4px',
    listStyle: 'none',
    height: '100%',
    '&::-webkit-scrollbar': {
      width: '8px',
      marginRight: '2px',
      marginLeft: '2px'
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '5px',
      backgroundColor: '#EBEBEB'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '5px',
      backgroundColor: '#A6A6A6'
    }
  }
}))
